import ActionTypes from "../ActionTypes/Media";

const initial_state = {
  savedMedia: [],
  savedGeneralContent: [],
  generalInfoSubmitted: false,
  disabled: true,
  onSaveAudioTrack: [],
  onSaveTranslation: [],
  onSaveSubtitle: [],
  trailerData: [],
  categoriesForUpdate: [],
  generalContentObj: [],
  savedMediaVideo: [],
  savedGeneralContentVideo: [],
  generalContentObjVideo: [],
  showThumbnail: [],
  savedMediaShow: [],
  seasonList: "",
  episodeList: "",
  seasonData: [],
  episodeData: [],
  savedSeason: [],
  savedEpisode: [],
  episodeThumbnail: [],
  generalContentObjShow: [],
  tvShowTrailer: [],
  generalContentObjEpisode: [],
  generalContentObjEpisodeInfo: [],
  savedMediaPodcast: [],
  podcastThumbnail: [],
  generalContentObjPodcast: [],
  podcastTrailer: [],
  savedPodcastEpisode: [],
  podcastEpisodeThumbnail: [],
  generalContentObjPodcastEpisode: [],
  generalContentObjPodcastEpisodeInfo: [],
  savedPodastSeason: [],
  savedMediaChannel: [],
  generalContentObjChannel: [],
  channelThumbnail: [],
  userDetailsData: [],
  savedAdmin: [],
  adminObj: [],
  broadcastDetails: [],
  savedFAQ: [],
};

const UploadMediaReducer = (state = initial_state, action) => {
  switch (action.type) {
    case ActionTypes.CREATE_GENERAL_CONTENT:
      return {
        ...state,
        savedMedia: [action.payload.savedMedia],
        savedGeneralContent: [action.payload.savedGeneralContent],
        generalInfoSubmitted: action.payload.generalInfoSubmitted,
        // disabled: action.payload.disabled,
      };
    // case 2
    case ActionTypes.ON_MEDIA_UPLOAD:
      return {
        ...state,
        savedMedia: [action.payload.updatedMedia],
      };
    // case 3
    case ActionTypes.ADD_AUDIO_TRACKS:
      return {
        ...state,
        savedMedia: [action.payload.updatedMediaResult],
        onSaveAudioTrack: [action.payload.onSaveAudioTrack],
        // onSaveTranslation: [action.payload.onSaveTranslation],
      };
    // case 4
    case ActionTypes.ADD_SUBTITLES:
      return {
        ...state,
        savedMedia: [action.payload.updatedMediaResult],
        onSaveSubtitle: [action.payload.onSaveSubtitle],
      };

    case ActionTypes.UPLOAD_TRAILER:
      return {
        ...state,

        trailerData: [action.payload.savedTrailer],
      };
    // get categories from edit for update
    case ActionTypes.GET_CATEGORY:
      if (action.payload.length === 0) {
        return { ...state, categoriesForUpdate: [] };
      } else {
        return {
          ...state,
          categoriesForUpdate: [
            ...state.categoriesForUpdate,
            ...action.payload,
          ],
        };
      }
    case ActionTypes.UPDATE_GENERAL_CONTENT_MOVIE:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObj: [],
          savedMedia: [],
          trailerData: [],
        };
      } else {
        return {
          ...state,
          generalContentObj: [action.payload],
          savedMedia: [action.payload.media],
          trailerData: [action.payload.trailer],
        };
      }

    // VIDEO General Content
    case ActionTypes.CREATE_VIDEO_GENERAL_CONTENT:
      return {
        ...state,
        savedMediaVideo: [action.payload.savedMedia],
        savedGeneralContentVideo: [action.payload.savedVideoContent],
      };
    case ActionTypes.UPDATE_GENERAL_CONTENT_VIDEO:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObjVideo: [],
          savedMediaVideo: [],
        };
      } else {
        return {
          ...state,
          generalContentObjVideo: [action.payload.videoContentObj],
          savedMediaVideo: [action.payload.videoContentObj.media],
        };
      }

    case ActionTypes.ON_VIDEO_MEDIA_UPLOAD:
      return {
        ...state,
        savedMediaVideo: [action.payload.updatedMedia],
      };
    case ActionTypes.CREATE_SHOW_GENERAL_CONTENT:
      return {
        ...state,
        savedMediaShow: [action.payload.savedTvShow],
        showThumbnail: [action.payload.thumbnail],
      };
    case ActionTypes.SEASON_LIST:
      return {
        ...state,
        seasonList: action.payload,
      };
    case ActionTypes.EPISODE_LIST:
      return {
        ...state,
        episodeList: action.payload,
      };
    case ActionTypes.CREATE_SEASON_GENERAL_CONTENT:
      return {
        ...state,
        savedSeason: [action.payload.savedSeason],
      };
    case ActionTypes.CREATE_EPISODE_GENERAL_CONTENT:
      return {
        ...state,
        savedEpisode: [action.payload.savedEpisode],
        episodeThumbnail: [action.payload.thumbnail],
      };
    case ActionTypes.ON_EPISODE_MEDIA_UPLOAD:
      return {
        ...state,
        savedEpisode: [action.payload.updatedEpisode],
        episodeThumbnail: [action.payload.updatedThumbnail],
      };
    case ActionTypes.UPDATE_GENERAL_CONTENT_SHOW:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObjShow: [],
          savedMediaShow: [],
          showThumbnail: [],
          tvShowTrailer: [],
        };
      } else {
        return {
          ...state,
          generalContentObjShow: [action.payload],
          showThumbnail: [action.payload.thumbnail],
          tvShowTrailer: [action.payload.trailer],
          savedMediaShow: [action.payload],
        };
      }
    case ActionTypes.UPLOAD_TRAILER_SHOW:
      return {
        ...state,
        tvShowTrailer: [action.payload.savedTrailer],
      };
    case ActionTypes.UPDATE_GENERAL_CONTENT_EPISODE:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObjEpisode: [],
          savedEpisode: [],
          episodeThumbnail: [],
        };
      } else {
        return {
          ...state,
          generalContentObjEpisode: [action.payload],
          savedEpisode: [action.payload],
          episodeThumbnail: [action.payload.thumbnail],
        };
      }
    // for episode info page
    case ActionTypes.GET_GENERAL_CONTENT_EPISODE_INFO:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObjEpisodeInfo: [],
        };
      } else {
        return {
          ...state,
          generalContentObjEpisodeInfo: [action.payload],
        };
      }
    // podcast ---------------------
    case ActionTypes.CREATE_PODCAST_GENERAL_CONTENT:
      return {
        ...state,
        savedMediaPodcast: [action.payload.savedPodcast],
        podcastThumbnail: [action.payload.thumbnail],
      };
    case ActionTypes.UPDATE_GENERAL_CONTENT_PODCAST:
      if (action.payload.length === 0) {
        return {
          ...state,
          savedMediaPodcast: [],
          podcastThumbnail: [],
          generalContentObjPodcast: [],
          podcastTrailer: [],
        };
      } else {
        return {
          ...state,
          generalContentObjPodcast: [action.payload],
          podcastThumbnail: [action.payload.thumbnail],
          podcastTrailer: [action.payload.trailer],
          savedMediaPodcast: [action.payload],
        };
      }
    case ActionTypes.UPLOAD_TRAILER_PODCAST:
      return {
        ...state,
        podcastTrailer: [action.payload.savedTrailer],
      };
    case ActionTypes.CREATE_PODCAST_EPISODE_GENERAL_CONTENT:
      return {
        ...state,
        savedPodcastEpisode: [action.payload.savedEpisode],
        podcastEpisodeThumbnail: [action.payload.thumbnail],
      };
    case ActionTypes.UPDATE_GENERAL_CONTENT_PODCAST_EPISODE:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObjPodcastEpisode: [],
          savedPodcastEpisode: [],
          podcastEpisodeThumbnail: [],
        };
      } else {
        return {
          ...state,
          generalContentObjPodcastEpisode: [action.payload],
          savedPodcastEpisode: [action.payload],
          podcastEpisodeThumbnail: [action.payload.thumbnail],
        };
      }
    case ActionTypes.GET_GENERAL_CONTENT_PODCAST_EPISODE_INFO:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObjPodcastEpisodeInfo: [],
        };
      } else {
        return {
          ...state,
          generalContentObjPodcastEpisodeInfo: [action.payload],
        };
      }
    case ActionTypes.ON_PODCAST_EPISODE_MEDIA_UPLOAD:
      return {
        ...state,
        savedPodcastEpisode: [action.payload.updatedEpisode],
        podcastEpisodeThumbnail: [action.payload.updatedThumbnail],
      };
    case ActionTypes.CREATE_PODCAST_SEASON_GENERAL_CONTENT:
      return {
        ...state,
        savedPodastSeason: [action.payload.savedSeason],
      };
    // CHANNEL-========================
    case ActionTypes.CREATE_CHANNEL_GENERAL_CONTENT:
      return {
        ...state,
        savedMediaChannel: [action.payload.savedChannel],
        channelThumbnail: [action.payload.savedThumbnail],
      };
    case ActionTypes.UPDATE_GENERAL_CONTENT_CHANNEL:
      if (action.payload.length === 0) {
        return {
          ...state,
          generalContentObjChannel: [],
          savedMediaChannel: [],
        };
      } else {
        return {
          ...state,
          generalContentObjChannel: [action.payload],
          savedMediaChannel: [action.payload],
        };
      }
    case ActionTypes.USER_INFO:
      if (action.payload.length === 0) {
        return {
          ...state,
          userDetailsData: [],
        };
      } else {
        return {
          ...state,
          userDetailsData: [action.payload],
        };
      }

    case ActionTypes.CREATE_ADMIN:
      return {
        ...state,
        savedAdmin: [action.payload.savedAdmin],
      };
    case ActionTypes.UPDATE_ADMIN_INFO:
      if (action.payload.length === 0) {
        return {
          ...state,

          savedAdmin: [],
        };
      } else {
        return {
          ...state,

          savedAdmin: [action.payload],
        };
      }
    case ActionTypes.BROADCAST_INFO:
      if (action.payload.length === 0) {
        return {
          ...state,
          broadcastDetails: [],
        };
      } else {
        return {
          ...state,
          broadcastDetails: [action.payload],
        };
      }
    case ActionTypes.UPDATE_FAQ:
      if (action.payload.length === 0) {
        return {
          ...state,
          savedFAQ: [],
        };
      } else {
        return {
          ...state,
          savedFAQ: [action.payload],
        };
      }
    default:
      return state;
  }
};

export default UploadMediaReducer;
